import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getFleet } from "../../lib/api";
import useFleetStore from "../../utils/store";
import { removeQueryParam } from "../../utils/queryParamNavigation";
import LoadingModal from "../Common/LoadingModal";

const SELECTED_FLEET_QUERY_PARAM = "selectedFleet";

const SelectedFleetQueryParamLoader = ({ children, currentUser, skipLoadingGate = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSelectedFleet } = useFleetStore();
  const [loading, setLoading] = useState(true);
  const attemptedFleetLoadRef = useRef(null);


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const selectedFleetUnid = searchParams.get(SELECTED_FLEET_QUERY_PARAM);
    const isCustomerUser = currentUser?.userType === "Customer";

    if (!isCustomerUser || !selectedFleetUnid) {
      setLoading(false);
      return;
    }

    if (attemptedFleetLoadRef.current === selectedFleetUnid) {
      return;
    }

    attemptedFleetLoadRef.current = selectedFleetUnid;

    const loadFleetFromQueryParam = async () => {
      try {
        setLoading(true);
        const response = await getFleet(selectedFleetUnid);
        const fleet = response?.data?.zone;

        if (response?.status === 200 && fleet) {
          setSelectedFleet(fleet);
          await removeQueryParam(navigate, SELECTED_FLEET_QUERY_PARAM);
        }
      } catch (error) {
        console.error("Failed to load selected fleet from query parameter:", error);
      } finally {
        setLoading(false);
      }
    };

    loadFleetFromQueryParam();
  }, [
    currentUser,
    location.search,
    navigate,
    setLoading,
    setSelectedFleet,
  ]);

  if (loading && !skipLoadingGate) {
    return <LoadingModal />;
  }
  return children;
};

export default SelectedFleetQueryParamLoader;
